import React from 'react';
import { Helmet } from 'react-helmet';
import './pagestyles/TechAtRedboxGlobal.css';

// const TechAtRedboxGlobal = () => {
//   return (
//     <>
//       <Helmet>
//         <title>Tech at Redbox Global - Innovation & Technology Careers | Redbox Global</title>
//         <meta name="description" content="Discover cutting-edge technology and innovation at Redbox Global. Learn about our engineering culture, tech stack, AI/ML initiatives, and opportunities to build next-generation financial platforms." />
//         <meta name="keywords" content="Redbox Global technology, engineering careers, software development, AI machine learning, fintech innovation, data engineering, cloud infrastructure, tech culture, developer jobs" />
        
//         {/* Open Graph / Facebook */}
//         <meta property="og:type" content="website" />
//         <meta property="og:url" content="https://redboxglobal.com/tech" />
//         <meta property="og:title" content="Tech at Redbox Global - Innovation & Technology Careers" />
//         <meta property="og:description" content="Join our engineering teams building cutting-edge technology that powers real-time financial news and data delivery to millions worldwide." />
//         <meta property="og:image" content="https://images.unsplash.com/photo-1518432031352-d6fc5c10da5a?w=1200&h=630&fit=crop" />
        
//         {/* Twitter */}
//         <meta name="twitter:card" content="summary_large_image" />
//         <meta name="twitter:url" content="https://redboxglobal.com/tech" />
//         <meta name="twitter:title" content="Tech at Redbox Global - Innovation & Technology Careers" />
//         <meta name="twitter:description" content="Build the future of financial technology with our world-class engineering teams." />
//         <meta name="twitter:image" content="https://images.unsplash.com/photo-1518432031352-d6fc5c10da5a?w=1200&h=630&fit=crop" />
        
//         {/* Additional SEO */}
//         <meta name="robots" content="index, follow" />
//         <meta name="author" content="Redbox Global" />
//         <link rel="canonical" href="https://redboxglobal.com/tech" />
        
//         {/* Structured Data */}
//         <script type="application/ld+json">
//           {JSON.stringify({
//             "@context": "https://schema.org",
//             "@type": "WebPage",
//             "name": "Tech at Redbox Global",
//             "description": "Explore technology, engineering culture, and innovation at Redbox Global's technology division.",
//             "url": "https://redboxglobal.com/tech",
//             "publisher": {
//               "@type": "Organization",
//               "name": "Redbox Global",
//               "logo": {
//                 "@type": "ImageObject",
//                 "url": "https://redboxglobal.com/logo.png"
//               }
//             },
//             "about": {
//               "@type": "Thing",
//               "name": "Technology and Engineering"
//             }
//           })}
//         </script>
//       </Helmet>
      
//       <div className="page-container">
//       <div className="page-header">
//         <h1>Tech at Redbox Global</h1>
//         <p className="page-subtitle">Building the future of financial news technology with innovation and excellence</p>
//       </div>
      
//       <div className="page-content">
//         <a href="/article/engineering-culture-innovation" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
//           <div className="featured-article">
//             <div className="featured-image">
//               <img src="https://images.unsplash.com/photo-1518432031352-d6fc5c10da5a?w=1200&h=600&fit=crop" alt="Technology and software development" />
//             </div>
//             <div className="featured-content">
//               <span className="article-category">Engineering Excellence</span>
//               <h2>Where Innovation Meets Impact: Engineering at Redbox Global</h2>
//               <p>At Redbox Global, our engineering teams build and maintain the infrastructure that delivers real-time financial news to millions of professionals worldwide. From AI-powered content analysis to ultra-low latency data delivery systems, discover how we're pushing the boundaries of what's possible in financial technology and creating tools that shape global markets.</p>
//               <span className="article-meta">Tech Culture</span>
//             </div>
//           </div>
//         </a>

//         <div className="content-grid">
//           <a href="/article/ai-ml-financial-news" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
//             <article className="article-card">
//               <div className="article-image">
//                 <img src="https://images.unsplash.com/photo-1677442136019-21780ecad995?w=600&h=400&fit=crop" alt="AI and Machine Learning" />
//               </div>
//               <div className="article-content">
//                 <span className="article-category">AI & ML</span>
//                 <h2>AI-Powered News Intelligence: The Future is Here</h2>
//                 <p>Our machine learning engineers are developing sophisticated algorithms that process millions of data points per second, delivering personalized insights and predictive analytics to our users.</p>
//                 <span className="article-meta">Innovation Lab</span>
//               </div>
//             </article>
//           </a>

//           <a href="/article/cloud-infrastructure-scale" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
//             <article className="article-card">
//               <div className="article-image">
//                 <img src="https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=600&h=400&fit=crop" alt="Cloud infrastructure" />
//               </div>
//               <div className="article-content">
//                 <span className="article-category">Infrastructure</span>
//                 <h2>Building Cloud Infrastructure That Scales Globally</h2>
//                 <p>Learn how our platform engineering teams design and operate highly available, fault-tolerant systems that process billions of requests daily across multiple continents.</p>
//                 <span className="article-meta">Technical Deep Dive</span>
//               </div>
//             </article>
//           </a>

//           <a href="/article/open-source-contributions" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
//             <article className="article-card">
//               <div className="article-image">
//                 <img src="https://images.unsplash.com/photo-1556075798-4825dfaaf498?w=600&h=400&fit=crop" alt="Open source development" />
//               </div>
//               <div className="article-content">
//                 <span className="article-category">Open Source</span>
//                 <h2>Contributing to the Developer Community Worldwide</h2>
//                 <p>Redbox Global engineers actively contribute to open source projects and share knowledge through conferences, meetups, and technical publications.</p>
//                 <span className="article-meta">Community</span>
//               </div>
//             </article>
//           </a>
//         </div>
//       </div>
//     </div>
//     </>
//   );
// };

// export default TechAtRedboxGlobal;





const TechAtRedboxGlobal = () => {
  return (
    <>
      <Helmet>
        <title>Tech at Redbox Global - Innovation, AI & Digital Future</title>
        <meta
          name="description"
          content="Explore technology at Redbox Global: artificial intelligence, digital transformation, emerging tech, and innovation shaping the future."
        />
        <meta
          name="keywords"
          content="technology, AI, artificial intelligence, innovation, digital transformation, emerging technology, future tech"
        />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://redboxglobal.com/tech" />
        <meta
          property="og:title"
          content="Tech at Redbox Global - Innovation & Digital Future"
        />
        <meta
          property="og:description"
          content="Inside Redbox Global’s technology, innovation, and digital leadership."
        />
        <meta
          property="og:image"
          content="https://images.unsplash.com/photo-1518770660439-4636190af475?w=1200&h=630&fit=crop"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Tech at Redbox Global" />
        <meta
          name="twitter:description"
          content="Innovation, AI, and emerging technology at Redbox Global."
        />
        <meta
          name="twitter:image"
          content="https://images.unsplash.com/photo-1518770660439-4636190af475?w=1200&h=630&fit=crop"
        />

        <link rel="canonical" href="https://redboxglobal.com/tech" />
      </Helmet>

      <div className="page-container">
        <div className="page-header">
          <h1>Tech</h1>
          <p className="page-subtitle">
            Innovation, intelligence, and the future of digital leadership
          </p>
        </div>

        <div className="page-content">
          {/* Featured Article */}
          <a
            href="/article/ai-driving-global-transformation"
            style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
          >
            <div className="featured-article">
              <div className="featured-image">
                <img
                  src="https://images.unsplash.com/photo-1518770660439-4636190af475?w=1200&h=600&fit=crop"
                  alt="Artificial intelligence technology"
                />
              </div>
              <div className="featured-content">
                            
                            
                <h2>How Artificial Intelligence Is Driving Global Transformation</h2>
                <p>
                  From automation to decision intelligence, AI is redefining how
                  organizations operate, innovate, and scale worldwide.
                </p>
                <span className="article-meta">Featured This Week</span>
              </div>
            </div>
          </a>

          {/* Article Grid */}
          <div className="content-grid">
            <a
              href="/article/digital-transformation-strategy"
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <article className="article-card">
                <div className="article-image">
                  <img
                    src="https://images.unsplash.com/photo-1555949963-aa79dcee981c?w=600&h=400&fit=crop"
                    alt="Digital transformation"
                  />
                </div>
                <div className="article-content">
                 
                  <h2>Digital Transformation as a Competitive Advantage</h2>
                  <p>
                    Why forward-thinking organizations are investing heavily in
                    digital-first strategies.
                  </p>
                  <span className="article-meta">February 5, 2026</span>
                </div>
              </article>
            </a>

            <a
              href="/article/future-of-cybersecurity"
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <article className="article-card">
                <div className="article-image">
                  <img
                    src="https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=600&h=400&fit=crop"
                    alt="Cybersecurity"
                  />
                </div>
                <div className="article-content">
                  
                  <h2>The Future of Cybersecurity in a Connected World</h2>
                  <p>
                    As technology evolves, so do threats. Here’s how companies
                    are staying resilient.
                  </p>
                  <span className="article-meta">February 3, 2026</span>
                </div>
              </article>
            </a>

            <a
              href="/article/emerging-tech-trends-2026"
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <article className="article-card">
                <div className="article-image">
                  <img
                    src="https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=600&h=400&fit=crop"
                    alt="Emerging technology"
                  />
                </div>
                <div className="article-content">
                 
                  <h2>Emerging Technology Trends to Watch in 2026</h2>
                  <p>
                    From quantum computing to spatial interfaces, these trends
                    are shaping tomorrow.
                  </p>
                  <span className="article-meta">February 1, 2026</span>
                </div>
              </article>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default TechAtRedboxGlobal;

